import { useState } from "react";
import Dashboard from "../../Dashboard/Dashboard";
function Home(props) {
  return (
    <>
      <Dashboard />
    </>
  );
}

export default Home;
